/**
 * Rebuy cart close observer
 * - On cart close: clear BaB selection, remove awt-bab-open, set footer button to "View Cart" (::before) and ::after font-size 0
 * - When cart has cleared: same button shows "View Cart" and opens Rebuy cart on click
 * - When user makes a new selection: button returns to "Confirm Order" / Add to cart
 */
(function () {
  var CART_ID = 'rebuy-cart';
  var VISIBLE_CLASS = 'is-visible';
  var BAB_BODY_CLASS = 'awt-bab-open';
  var VIEW_CART_MODE_CLASS = 'rebuy-bab-view-cart-mode';

  function runWhenCartExists(callback) {
    var el = document.getElementById(CART_ID);
    if (el) {
      callback(el);
      return;
    }
    var observer = new MutationObserver(function (mutations, obs) {
      var cart = document.getElementById(CART_ID);
      if (cart) {
        obs.disconnect();
        callback(cart);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function getCardQuantity(card) {
    var q = card.getAttribute('data-quantity');
    if (q !== null && q !== undefined) return parseInt(q, 10) || 0;
    var container = card.querySelector('.bundle-product-card__quantity-button-container');
    if (container) {
      var span = container.querySelector('span');
      if (span) return parseInt(span.textContent, 10) || 0;
    }
    return 0;
  }

  function clickDecrementUntilZero(card, callback) {
    var container = card.querySelector('.bundle-product-card__quantity-button-container');
    if (!container) {
      if (callback) callback();
      return;
    }
    var decBtn = container.querySelector('[data-testid="decrement-quantity"]') || container.querySelector('button');
    if (!decBtn) {
      if (callback) callback();
      return;
    }
    var current = getCardQuantity(card);
    if (current <= 0) {
      if (callback) callback();
      return;
    }
    var clicks = 0;
    var maxClicks = 50;
    function doClick() {
      if (clicks >= current || clicks >= maxClicks) {
        if (callback) callback();
        return;
      }
      decBtn.click();
      clicks += 1;
      setTimeout(doClick, 80);
    }
    doClick();
  }

  function getTotalBundleQuantity() {
    var cards = document.querySelectorAll('.bundle-product-card');
    var total = 0;
    cards.forEach(function (card) {
      total += getCardQuantity(card);
    });
    return total;
  }

  function clearBundleProductCards(done) {
    var cards = document.querySelectorAll('.bundle-product-card');
    var total = 0;
    cards.forEach(function (card) {
      var q = getCardQuantity(card);
      if (q > 0) total += q;
    });
    if (total === 0) {
      if (done) done();
      return;
    }
    var index = 0;
    function runNext() {
      if (index >= cards.length) {
        console.log('[Rebuy cart] Set all bundle product card quantities to 0');
        if (done) done();
        return;
      }
      var card = cards[index];
      index += 1;
      clickDecrementUntilZero(card, runNext);
    }
    runNext();
  }

  function openRebuyCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
    }
  }

  function setViewCartMode(active) {
    var container = document.querySelector('[data-bl-btn-init="1"]');
    if (!container) return;
    var btn = container.querySelector('button.bundle-button.button--primary[name="checkout"]');
    if (active) {
      container.classList.add(VIEW_CART_MODE_CLASS);
      if (btn) {
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-disabled', 'false');
      }
    } else {
      container.classList.remove(VIEW_CART_MODE_CLASS);
      if (btn && getTotalBundleQuantity() === 0) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function updateViewCartMode() {
    var total = getTotalBundleQuantity();
    setViewCartMode(total === 0);
  }

  function onCartClosed() {
    console.log('[Rebuy cart] Cart closed — is-visible class removed');
    document.body.classList.remove(BAB_BODY_CLASS);
    clearBundleProductCards(function () {
      setViewCartMode(true);
    });
  }

  function observeCartVisibility(cart) {
    var hadVisible = cart.classList.contains(VISIBLE_CLASS);
    var classObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var nowVisible = cart.classList.contains(VISIBLE_CLASS);
          if (hadVisible && !nowVisible) {
            onCartClosed();
          }
          hadVisible = nowVisible;
        }
      });
    });
    classObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
    hadVisible = cart.classList.contains(VISIBLE_CLASS);
  }

  function startBundleFooterPoll() {
    document.addEventListener('click', function (e) {
      var container = document.querySelector('[data-bl-btn-init="1"].' + VIEW_CART_MODE_CLASS);
      if (!container) return;
      var btn = e.target && e.target.closest && e.target.closest('button.bundle-button.button--primary[name="checkout"]');
      if (!btn || !container.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      openRebuyCart();
    }, true);
    setInterval(function () {
      var container = document.querySelector('[data-bl-btn-init="1"]');
      if (!container) return;
      var total = getTotalBundleQuantity();
      if (total > 0) {
        container.classList.remove(VIEW_CART_MODE_CLASS);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runWhenCartExists(observeCartVisibility);
      startBundleFooterPoll();
    });
  } else {
    runWhenCartExists(observeCartVisibility);
    startBundleFooterPoll();
  }
})();
